require('dotenv').config({ path: '.env' });
const { BrowserTracing } = require('@sentry/tracing');

const { APP_MODE } = process.env;
const isStagingApp = APP_MODE === 'staging';

const clientErrorsToIgnore = [
  'Non-Error exception captured with keys',
  "Cannot read properties of undefined (reading 'offsetWidth')",
  "undefined is not an object (evaluating 't.canvasRef.offsetWidth')",
  't.canvasRef is undefined',
  't.domNode[l.DATA_KEY].mutations',
  's.position is not a function',
  'ResizeObserver loop limit exceeded',
  'a.position is not a function', // related to the "quill editor", doesn't affect the system
  't.split(...).at is not a function',
  'null is not an object (evaluating \'localStorage.getItem\')', // ST-3859
];

const serverErrorsToIgnore = [
  'Invalid login: 454-4.7.0 Too many login attempts', // NOTE: related to API tests and the sending email logic
];

const config = {
  client: {
    dsn: process.env.CLIENT_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: process.env.APP_MODE,
    ignoreErrors: clientErrorsToIgnore,
  },
  server: {
    dsn: process.env.SENTRY_DSN,
    environment: process.env.APP_MODE,
    ignoreErrors: isStagingApp ? serverErrorsToIgnore : [],
  },
};

module.exports = config;
